var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    fill: "#059157",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0407 22.9207C24.1462 26.0641 21.4266 29.7229 20.8832 33.8972C20.0363 40.3953 25.8473 43.5757 28.7918 40.7183C31.7363 37.8603 29.9715 34.2333 27.8395 33.2414C25.7075 32.2501 24.4036 32.5953 24.6311 31.2706C24.8586 29.9452 27.8915 26.2721 30.5565 24.5606C30.651 24.4803 30.7112 24.367 30.725 24.2438C30.7388 24.1206 30.705 23.9968 30.6306 23.8976L29.9715 23.0403C29.6855 22.6685 29.4112 22.6828 29.0407 22.92V22.9207ZM41.9276 22.9207C37.0331 26.0641 34.3135 29.7229 33.7701 33.8972C32.9232 40.3953 38.7342 43.5757 41.6787 40.7183C44.6232 37.8603 42.8584 34.2333 40.7258 33.2414C38.5938 32.2501 37.2899 32.5953 37.5174 31.2706C37.7449 29.9452 40.7784 26.2721 43.4434 24.5606C43.5378 24.4802 43.5979 24.3669 43.6116 24.2437C43.6252 24.1205 43.5913 23.9967 43.5169 23.8976L42.8578 23.0403C42.5718 22.6685 42.2975 22.6828 41.9276 22.92V22.9207Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2);
export default __webpack_public_path__ + "static/media/Group 2.676b415ecb080903b0b334b95bf006cb.svg";
export { ForwardRef as ReactComponent };